/* to do list css */
import styled from 'styled-components';

export const ToDoWrapper = styled.div`
.to-do-list-p {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.54;
    letter-spacing: normal;
    color: #2b639a;
    line-height: 0.2px;
}

.to-do-list-p1 {
    color: #66c3df;
    line-height: 1px;
}

.card-accent-warning {
    border-top-color: #ffc107;
    border-top-width: 3px;
    border-radius: 0 !important;
}

.card-accent-danger {
    border-top-color: #f86c6b;
    border-top-width: 3px;
    border-radius: 0 !important;
}

.card-accent-secondary {
    border-top-color: #c8ced3;
    border-top-width: 3px;
    border-radius: 0 !important;
}

.todo-sec h5 {
    font-size: 16px;
}

.events {
    padding: 5px 15px 5px 15px;
    margin-right: 4px;
    border: 1px solid #979797;
    text-align: center;
    font-size: 18px;
}

.events p {
    margin-bottom: 0px;
}

.events-info h6 {
    line-height: 2px;
    margin-top: 12px;
    font-weight: normal;
    font-size: 12px;
    color: #333;
}

.events-info p {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
}

.events-month {
    font-size: 16px;
    font-weight: normal;
    color: #333333;
}

.events-date {
    font-weight: 700;
    font-size: 24px;
}

.tab-message {
    margin-top: 25px;
}

.ytp-title * {
    display: none !important;
}

.events-p {
    color: #3a6497;
    font-weight: bold;
    letter-spacing: normal;
    font-size: 14px;
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 0px;
}

.event-sec .card-body h5 {
    font-size: 16px;
}

.events{
    padding:5px 15px 5px 15px;
        margin-right:4px;
        border:1px solid #979797;
        text-align: center;
        font-size: 18px;
    }
    
    
    .events p{
    margin-bottom: 0px;
    
    }
    
    .events-info h6{
    line-height: 2px;
    margin-top:12px;
    font-weight: normal;
    font-size: 12px;
    color:#333;
    }
    .events-info p{
    font-size: 14px;
    font-weight: bold;
    color:#333333;
    }
    .events-month{
        font-size: 16px;
        font-weight: normal;
        color:#333333;
    }
    .events-date{
    font-weight: 700;
    font-size: 24px;	
    }
    
    .tab-message{
    margin-top: 25px;
    }
    .ytp-title *{
    display: none !important;
    }
    
    .events-p{
    color:#3a6497;
    font-weight: bold;
    letter-spacing: normal;
    font-size: 14px;
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 0px;
    }
    
    .event-sec .card-body h5{
        font-size: 16px;
    }
    .event-class{
        width: 200px !important;
        margin: 30px auto!important;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #333333;
    }
    .event-class span{
        color: #21a8d8;
    }
    .webinar-button{
        height: 35px;
        line-height: 20px;
      border-radius: 3px;
      background-color: #083ac8;
      border-color: #083ac8;
      font-size: 15px;
      font-weight: normal;
      letter-spacing: 0.21px;
      text-align: center;
      width: 100%;
    }
    
`;